import { render } from "./TextManagement.vue?vue&type=template&id=461e41f6"
import script from "./TextManagement.vue?vue&type=script&lang=js"
export * from "./TextManagement.vue?vue&type=script&lang=js"

import "./TextManagement.vue?vue&type=style&index=0&id=461e41f6&lang=scss&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__